module["exports"] = [
  "вул.",
  "вулиця",
  "пр.",
  "проспект",
  "пл.",
  "площа",
  "пров.",
  "провулок"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/uk/address/street_prefix.js
 ** module id = 1045
 ** module chunks = 0
 **/